import { Component, input } from '@angular/core';

@Component({
  selector: 'faq-qa',
  templateUrl: './faq-qa.html',
  styleUrl: './faq-qa.scss',
})
export class FaqQa {
  readonly question = input.required<string>();
  readonly answer = input.required<string>();
}
